import clsx from 'clsx'
import React, { useMemo } from 'react'

import { type GraphUIProps } from './graph-types'
import {
  DEFAULT_GRAPH_OPTIONS,
  GraphComponentMapper,
  mergeOptions,
} from './mapper'

export const GraphUI: React.FC<GraphUIProps> = ({
  data,
  type,
  className = '',
  options = {},
}) => {
  const Component = GraphComponentMapper[type] || GraphComponentMapper.default

  const defaultOptions = mergeOptions(DEFAULT_GRAPH_OPTIONS, {
    scales: {
      y: {
        max: Math.max(...data.datasets.map((d) => Math.max(...d.data))),
      },
    },
  })

  const mergedOptions = useMemo(
    () => mergeOptions(options, defaultOptions),
    [options]
  )
  return (
    <div className={clsx('flex flex-col items-center', className)}>
      <Component data={data} options={mergedOptions} redraw={true} />
    </div>
  )
}
